<template>
  <ConfigLayout current="coursemenu">
    <ConfigPage title="コースの並べ替え" showBack @back="goBack">
      <template #header>
        <Button @click="goBack">キャンセル</Button>
        <Button class="is-lead" @click="onSave" :disabled="!changed">保存</Button>
      </template>
      <DraggableTable
        class="courses"
        v-model="coursesOrders"
        :columns="[
          { key: 'name', name: 'コース' },
          { key: 'price', name: '金額' },
        ]"
        :loading="busy"
      >
        <template #name="{ item }">{{ item.names.jpn }}</template>
        <template #price="{ item }"> {{ numberFormat(item.price) }}円 </template>
      </DraggableTable>
    </ConfigPage>
  </ConfigLayout>
</template>

<script>
import { mapState } from 'vuex'
import { isEqual } from 'lodash'
import { numberFormat } from '@/utils/number'
import ConfigLayout from '@/components/templates/ConfigLayout'
import ConfigPage from '@/components/templates/ConfigPage'
import Button from '@/components/atoms/Button'
import DraggableTable from '@/components/molecules/DraggableTable'

export default {
  name: 'CoursesOrder',
  components: {
    ConfigLayout,
    ConfigPage,
    Button,
    DraggableTable,
  },
  data() {
    return {
      coursesIds: null,
    }
  },
  computed: {
    ...mapState({
      courses: state => state.courses,
      busy: state => state.courses.busy,
    }),
    coursesOrders: {
      get() {
        return (this.coursesIds || this.courses.allIds).map(id => this.courses.byId[id])
      },
      set(courses) {
        this.coursesIds = Array.isArray(courses) && courses.map(course => course.id)
      },
    },
    changed() {
      return !!this.coursesIds && !isEqual(this.coursesIds, this.courses.allIds)
    },
  },
  watch: {
    changed() {
      this.$store.commit('app/editing', this.changed)
    },
  },
  async mounted() {
    await this.$store.dispatch('courses/get')
  },
  methods: {
    numberFormat,
    async onSave() {
      if (await this.$store.dispatch('courses/saveOrder', this.coursesIds)) {
        this.goBack()
      }
    },
    goBack() {
      this.$store.commit('app/editing', false)
      window.history.length > 1 ? this.$router.back() : this.$router.push({ name: 'coursemenu' })
    },
  },
}
</script>

<style lang="postcss" scoped>
.courses {
  >>> .name {
    padding: 8px 24px;
    white-space: normal;
  }
  >>> .price {
    min-width: 126px;
    white-space: initial;
    width: 126px;
  }

  >>> .main {
    .price {
      justify-content: right;
    }
  }
}
</style>
